import { Briefcase, Home, LineChart, Users } from "lucide-react";
import { HOME_PATH, isProductEnabled } from "../config/products";

export const BP_MARKETS_PATH = "/app/bond-predict";
export const BP_PORTFOLIO_PATH = "/app/bond-predict/portfolio";
export const BP_HOME_PATH = HOME_PATH;
export const BP_PROFILE_PATH = "/app/profile";
export const BP_DASHBOARD_PATH = "/app/dashboard";

/** Leave-desk shortcuts — workspace nav is hidden on BondPredict surfaces. */
export const BP_RAIL_ESCAPE_LINKS = [
  { to: BP_MARKETS_PATH, label: "Markets", Icon: LineChart, end: true },
  { to: BP_HOME_PATH, label: isProductEnabled("house") ? "House" : "P2P", Icon: isProductEnabled("house") ? Home : Users, end: true },
];

/** Market detail rail — includes portfolio beside house. */
export const BP_DETAIL_RAIL_ESCAPE_LINKS = [
  { to: BP_MARKETS_PATH, label: "Markets", Icon: LineChart, end: true },
  { to: BP_PORTFOLIO_PATH, label: "Portfolio", Icon: Briefcase },
  { to: BP_HOME_PATH, label: isProductEnabled("house") ? "House" : "P2P", Icon: isProductEnabled("house") ? Home : Users, end: true },
];
